import { iconMap, IconName, IconProps } from "..";

export const Icon: React.FC<IconProps & React.SVGProps<SVGSVGElement>> = ({
	iconId,
	className,
	...props
}: {
	iconId: IconName;
	className?: string;
} & React.SVGProps<SVGSVGElement>) => {
	const IconComponent = iconMap[iconId] as React.ElementType;
	return IconComponent ? (
		<IconComponent id={iconId} {...{ className, ...props }} />
	) : null;
};

export default Icon;
